import script from "./EditarNoticia.vue?vue&type=script&setup=true&lang=js"
export * from "./EditarNoticia.vue?vue&type=script&setup=true&lang=js"

import "./EditarNoticia.vue?vue&type=style&index=0&id=75d9cb5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75d9cb5a"]])

export default __exports__